var SpinnerGroup, SpinnerView;

SpinnerView = require('../../../spinner/frontend/views/spinner');

module.exports = SpinnerGroup = {
  spinners: {},
  addSpinner: function(name, options) {
    return this.spinners[name] = (new SpinnerView(options)).render();
  },
  removeSpinner: function(name) {
    var ref;
    if ((ref = this.spinners[name]) != null) {
      ref.remove();
    }
    return delete this.spinners[name];
  },
  start: function(name, options) {
    var ref, spinner;
    spinner = (ref = this.spinners[name]) != null ? ref : this.addSpinner(name, options).render();
    return spinner != null ? spinner.start() : void 0;
  },
  stop: function(name, options) {
    var ref, spinner;
    if (options != null ? options.remove : void 0) {
      return this.removeSpinner(name);
    }
    if (!((ref = (spinner = this.spinners[name])) != null ? ref.isRunning() : void 0)) {
      return;
    }
    return spinner.stop();
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC9oZWxwZXJzL3NwaW5uZXJfZ3JvdXAuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC9oZWxwZXJzL3NwaW5uZXJfZ3JvdXAuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsV0FBQSxHQUFjLE9BQUEsQ0FBUSx5Q0FBUjs7QUFFZCxNQUFNLENBQUMsT0FBUCxHQUFpQixZQUFBLEdBQ2Y7RUFBQSxRQUFBLEVBQVUsRUFBVjtFQUVBLFVBQUEsRUFBWSxTQUFDLElBQUQsRUFBTyxPQUFQO1dBQ1YsSUFBQyxDQUFBLFFBQVMsQ0FBQSxJQUFBLENBQVYsR0FBa0IsQ0FBQyxJQUFJLFdBQUosQ0FBZ0IsT0FBaEIsQ0FBRCxDQUEwQixDQUFDLE1BQTNCLENBQUE7RUFEUixDQUZaO0VBS0EsYUFBQSxFQUFlLFNBQUMsSUFBRDtBQUNiLFFBQUE7O1NBQWUsQ0FBRSxNQUFqQixDQUFBOztXQUNBLE9BQU8sSUFBQyxDQUFBLFFBQVMsQ0FBQSxJQUFBO0VBRkosQ0FMZjtFQVNBLEtBQUEsRUFBTyxTQUFDLElBQUQsRUFBTyxPQUFQO0FBQ0wsUUFBQTtJQUFBLE9BQUEsK0NBQTRCLElBQUMsQ0FBQSxVQUFELENBQVksSUFBWixFQUFrQixPQUFsQixDQUEwQixDQUFDLE1BQTNCLENBQUE7NkJBQzVCLE9BQU8sQ0FBRSxLQUFULENBQUE7RUFGSyxDQVRQO0VBYUEsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLE9BQVA7QUFDSixRQUFBO0lBQUEsc0JBQStCLE9BQU8sQ0FBRSxlQUF4QztBQUFBLGFBQU8sSUFBQyxDQUFBLGFBQUQsQ0FBZSxJQUFmLEVBQVA7O0lBQ0EsSUFBQSx1REFBeUMsQ0FBRSxTQUE3QixDQUFBLFdBQWQ7QUFBQSxhQUFBOztXQUNBLE9BQU8sQ0FBQyxJQUFSLENBQUE7RUFISSxDQWJOIn0=
